export function isBwBioscopeVersion(bioscopeVersion?: string): boolean {
    return bioscopeVersion === '1.0';
}

/** Bioscope 2.0 — smartwinch / Move bioscope. Undefined = no bioscope / unknown. */
export function isBioscopeV2(bioscopeVersion?: string): boolean {
    return bioscopeVersion === '2.0';
}

/** Bioscope 2.0 / 3.0 — health module pens. Undefined = no bioscope / unknown. */
export function isColorBioscopeVersion(bioscopeVersion?: string): boolean {
    return bioscopeVersion != null && bioscopeVersion !== '1.0';
}

/** First hardware generation with no SMS-reachable modem for restarts. */
export const FIRST_MAJOR_WITHOUT_SMS_RESTART = 3;

export function bioscopeMajorVersion(version?: string | null): number | null {
    const major = Number.parseInt(version ?? '', 10);
    return Number.isFinite(major) ? major : null;
}

/**
 * Version string used to decide SMS restart.
 *
 * Prefer the latest device-reported `bioscopeVersions.version`. Fall back to
 * `bioscopes.bioscopeVersion` only when nothing has been reported yet.
 */
export function resolveSmsRestartVersion(
    reportedVersion?: string | null,
    storedBioscopeVersion?: string | null
): string | null | undefined {
    if (reportedVersion != null && reportedVersion.trim() !== '') {
        return reportedVersion;
    }
    return storedBioscopeVersion;
}

/**
 * Whether a cabinet can be restarted over SMS.
 *
 * Unparseable versions fail open so a missing or garbage version does not hide
 * the restart tool from 1.0 / 2.0 hardware.
 */
export function supportsSmsRestart(bioscopeVersion?: string | null): boolean {
    const major = bioscopeMajorVersion(bioscopeVersion);
    return major === null || major < FIRST_MAJOR_WITHOUT_SMS_RESTART;
}
